var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 12.586v1.833a.458.458 0 0 1-.733.367l-3.664-2.75a.458.458 0 0 1 0-.733l3.664-2.75a.458.458 0 0 1 .733.366v1.834h9.88a.2.2 0 0 1 .2.2v1.433a.2.2 0 0 1-.2.2H5.25ZM11.483 1.22a.459.459 0 0 0-.733.366V3.42H.87a.2.2 0 0 0-.2.2v1.434c0 .11.089.2.2.2h9.88v1.833a.459.459 0 0 0 .733.367l3.664-2.75a.458.458 0 0 0 0-.734l-3.664-2.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.b14d22c5e4a816b88f97d550fba30140.svg";
export { ForwardRef as ReactComponent };